export const columns = [{
    name: 'Prop #',
    key: 'no'
}, {
    name: 'Close of Escrow',
    key: 'closeOfEscrow',
}, {
    name: 'Property Name',
    key: 'name',
}, {
    name: 'City',
    key: 'city',
}, {
    name: 'State',
    key: 'state',
}, {
    name: 'Total Fee',
    key: 'totalFee',
    class: 'Fees_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Listing Agent',
    subColumns: [{
        name: 'Agent 1',
        key: 'listingAgent1',
    }, {
        name: '%',
        key: 'listingAgent1Percent',
        class: 'Fees_column_numeric',
        format: '%',
    }, {
        name: '$',
        key: 'listingAgent1Price',
        class: 'Fees_column_numeric',
        format: '$',
        withCents: true,
    }, {
        name: 'Agent 2',
        key: 'listingAgent2',
    }, {
        name: '%',
        key: 'listingAgent2Percent',
        class: 'Fees_column_numeric',
        format: '%',
    }, {
        name: '$',
        key: 'listingAgent2Price',
        class: 'Fees_column_numeric',
        format: '$',
        withCents: true,
    }, {
        name: 'Agent 3',
        key: 'listingAgent3',
    }, {
        name: '%',
        key: 'listingAgent3Percent',
        class: 'Fees_column_numeric',
        format: '%',
    }, {
        name: '$',
        key: 'listingAgent3Price',
        class: 'Fees_column_numeric',
        format: '$',
        withCents: true,
    },]
}, {
    name: 'Buying Agent',
    subColumns: [{
        name: 'Agent 1',
        key: 'buyerAgent1',
    }, {
        name: '%',
        key: 'buyerAgent1Percent',
        class: 'Fees_column_numeric',
        format: '%',
    }, {
        name: '$',
        key: 'buyerAgent1Price',
        class: 'Fees_column_numeric',
        format: '$',
        withCents: true,
    },  {
        name: 'Agent 2',
        key: 'buyerAgent2',
    }, {
        name: '%',
        key: 'buyerAgent2Percent',
        class: 'Fees_column_numeric',
        format: '%',
    }, {
        name: '$',
        key: 'buyerAgent2Price',
        class: 'Fees_column_numeric',
        format: '$',
        withCents: true,
    },  {
        name: 'Agent 3',
        key: 'buyerAgent3',
    }, {
        name: '%',
        key: 'buyerAgent3Percent',
        class: 'Fees_column_numeric',
        format: '%',
    }, {
        name: '$',
        key: 'buyerAgent3Price',
        class: 'Fees_column_numeric',
        format: '$',
        withCents: true,
    },]
}, {
    name: 'Transaction Type',
    key: 'transactionType',
}, {
    name: 'STRIVE Fee',
    key: 'striveFee',
    class: 'Fees_column_numeric',
    format: '$',
    withCents: true,
},];

const splitColumnIndex = 7;
const cloneDeep = require("lodash.clonedeep");

export const printFirstColumns = cloneDeep(columns.slice(0, splitColumnIndex));
printFirstColumns[0].name = '#';

export const printSecondColumns = columns.slice(splitColumnIndex);
// keep the first 4 columns on the second page as well
printSecondColumns.unshift({...columns[0]}, columns[1], columns[2], columns[3]);
printSecondColumns[0].name = '#';